export default function checkIfCanSeeManageQuestionsRoutes({ next, store }) {
  let scopes = store.getters.userScopes;
  return scopes.includes('manage_questions') ? next() : next({ name: 'dashboard' });
}
